import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import React, { useState } from 'react';

interface PasswordFieldProps {
  label: string;
  value: string;
  name?: string;
  onChange: (val: string) => void;
  helperText?: string;
  errorMessage?: string | string[] | null;
  autoFocus?: boolean;
  onEnter?: () => void;
}

export const PasswordField: React.FC<PasswordFieldProps> = ({
  label,
  value,
  name,
  onChange,
  helperText,
  errorMessage,
  autoFocus = false,
  onEnter,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const hasError = Array.isArray(errorMessage) ? errorMessage.length > 0 : Boolean(errorMessage);

  const helperNode =
    hasError && Array.isArray(errorMessage) ? (
      <Box
        component="ul"
        sx={{
          m: 0,
          pl: 2,
          color: 'error.main',
          '& li': { mb: 0.5 },
        }}
      >
        {errorMessage.map((msg, i) => (
          <li key={i}>{msg}</li>
        ))}
      </Box>
    ) : (
      errorMessage || helperText
    );

  return (
    <TextField
      fullWidth
      label={label}
      value={value}
      name={name ?? ''}
      onChange={(e) => onChange(e.target.value)}
      type={showPassword ? 'text' : 'password'}
      error={hasError}
      helperText={helperNode}
      autoFocus={autoFocus}
      autoComplete="new-password"
      onKeyDown={(e) => {
        if (e.key === 'Enter' && onEnter) onEnter();
      }}
      InputProps={{
        endAdornment: value.length > 0 && (
          <InputAdornment position="end">
            <IconButton edge="end" onClick={() => setShowPassword((prev) => !prev)}>
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
